
import { Bill } from "../../types";

export function useBillsFilter(
  bills: Bill[],
  searchTerm: string,
  statusFilter: string
) {
  // Filter bills based on search and status
  const filteredBills = bills.filter(bill => {
    // Status filter
    if (statusFilter !== "all" && bill.status !== statusFilter) {
      return false;
    }

    // Search across multiple fields
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      return (
        bill.transaction_number?.toLowerCase().includes(searchLower) ||
        bill.plan?.name?.toLowerCase().includes(searchLower) ||
        bill.plan?.product?.name?.toLowerCase().includes(searchLower) ||
        bill.status?.toLowerCase().includes(searchLower) ||
        bill.description?.toLowerCase().includes(searchLower)
      );
    }

    return true;
  });

  return { filteredBills };
}
